module.exports = __webpack_public_path__ + "img/a-propos-prestations-3.1b77a593.png";